import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getTextEditorStyles = (theme: Theme) =>
    css({
        border: `1px solid ${theme.palette.gray.main}`,
        position: 'relative',

        '.text-editor-text-underline': {
            textDecoration: 'underline',
        },

        '.text-editor-text-italic': {
            fontStyle: 'italic',
        },

        '.text-editor-paragraph': {
            margin: `0 0 ${theme.spacing()}px 0`,

            ':last-child': {
                margin: 0,
            },
        },

        '.text-editor-tag': {
            backgroundColor: theme.palette.gray.ultraLight,
        },
    });

export const getContentEditableStyles = (theme: Theme) =>
    css({
        position: 'relative',
        outline: 'none',
        padding: theme.spacing(2),
        minHeight: 100,
        maxHeight: 200,
        overflowY: 'auto',
    });

export const getTextEditorInnerStyles = () =>
    css({
        position: 'relative',
    });
